var external_module;
(function() {
var module = angular.
  module('metadata.service')
  
  .config(function () {
    module.baseUrl = '${API_URL}/api/rest/metadata/';
  })
  
  .factory('Menu', ['$resource',
    function($resource) {
      return $resource(module.baseUrl + 'Menu/:menuId', {}, {
        query: {
          method: 'GET',
          //params: {alunoId: 'alunos'},
          isArray: true
        }
      });
    }
  ])
  
  .factory('MenuTree', ['$resource',
    function($resource) {
      return $resource('${API_URL}/pessoas/menu-aluno?aluno=:codAluno&pessoa=:codPessoa', {}, { 
        get: {
          method: 'GET',
          isArray: true
        }
      });
    }
  ]) 

  .factory('MenuGroup', ['$resource',
    function($resource) {
      return $resource('${API_URL}/pessoas/menu-aluno-agrupado?aluno=:codAluno&pessoa=:codPessoa', {}, { 
        get: {
          method: 'GET',
          isArray: true
        }
      });
    }
  ])
  
  .factory('Menu.Items', ['$resource',
    function($resource) {
      return $resource(module.baseUrl + 'Menu/:menuId/MenuItems', {}, {
        query: {
          method: 'GET',
          isArray: true
        }
      });
    }
  ])
  
  .factory('ParametrosIntegracaoSso', ['$resource',
    function($resource) {
      return $resource('${API_URL}/pessoas/codAluno/:codAluno/parametros-integracao-sso', {}, {
        query: {
          method: 'GET'
        }
      });
    }
  ]);
  
  external_module = module;
})();